import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      Hello
      "/_staff/it-operation-core/_detail/operation-packages/$packageId/$instanceId/_layout/operation-activity/"!
    </div>
  );
}
